import React from 'react';
import ContentLoader from 'react-content-loader';

type Props = {
    className?: string;
};

export const Loader = (props: Props) => (
    <ContentLoader
        speed={2}
        width={520}
        height={1112}
        viewBox="0 0 520 1112"
        backgroundColor="#f5f9ff"
        foregroundColor="#e3eeff"
        style={{flexShrink: 0}}
    >
        <rect x="3" y="22" rx="8" ry="8" width="588" height="40" />
        <rect x="3" y="72" rx="8" ry="8" width="588" height="40" />
        <rect x="3" y="122" rx="8" ry="8" width="588" height="40" />
        <rect x="3" y="172" rx="8" ry="8" width="588" height="40" />
        <rect x="3" y="222" rx="8" ry="8" width="588" height="40" />
        <rect x="3" y="272" rx="8" ry="8" width="588" height="40" />
        <rect x="3" y="322" rx="8" ry="8" width="588" height="40" />
        <rect x="3" y="372" rx="8" ry="8" width="588" height="40" />
        <rect x="3" y="422" rx="8" ry="8" width="588" height="40" />
        <rect x="3" y="472" rx="8" ry="8" width="588" height="40" />
        <rect x="3" y="522" rx="8" ry="8" width="588" height="40" />
        <rect x="3" y="572" rx="8" ry="8" width="588" height="40" />
        <rect x="3" y="622" rx="8" ry="8" width="588" height="40" />
        <rect x="3" y="672" rx="8" ry="8" width="588" height="40" />
    </ContentLoader>
);

export default Loader;
